// LQC-637 — RP/OP "Request Information" negotiation. Each negotiable field on an
// execution request carries a status describing where it sits in the request →
// response flow. The resolved field value is boolean at heart (True = shown to
// the RP, False = not), with two intermediate states while a request is in
// flight (Requested) or has been declined (Rejected).
export enum RequestInfoStatus {
  False = "False", // a request has never been made
  Requested = "Requested", // RP has asked, OP has not yet actioned
  Rejected = "Rejected", // OP responded and declined the request
  True = "True", // OP accepted, OR it was already true when first sent
}

// The four fields the RP can request and the OP can release/reject. Matches the
// body of /Trade/Execution/Request/Information (RP) and /Trade/Execution/Request
// (OP response).
export type RequestInfoField =
  | "direction"
  | "competition"
  | "cover"
  | "coverSpread";

// All four fields, used to iterate / validate incoming statuses.
export const REQUEST_INFO_FIELDS: RequestInfoField[] = [
  "direction",
  "competition",
  "cover",
  "coverSpread",
];

// Per-field statuses as the request-information endpoint returns them. Values
// arrive as raw strings and are validated against RequestInfoStatus before
// entering the store.
//
// NOTE (backend contract): the field NAMES below are assumed — confirm the
// /Trade/Execution/Requests payload uses these keys and adjust normalizeRequestInfo
// if not.
export interface IRequestInfoFromAPI {
  direction?: string;
  competition?: string;
  cover?: string;
  coverSpread?: string;
}

// Word shown beside the RP Request button (and reused by the OP view). False
// shows nothing — the button itself is the call-to-action when nothing's been
// requested yet.
export function requestInfoStatusLabel(status: RequestInfoStatus): string {
  switch (status) {
    case RequestInfoStatus.Requested:
      return "Requested";
    case RequestInfoStatus.Rejected:
      return "Rejected";
    case RequestInfoStatus.True:
      return "Released";
    case RequestInfoStatus.False:
    default:
      return "";
  }
}
